"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);









const isDev = SOCKET_SERVER_HOST !== 'api.bloomtext.com'

// Preserve the existing SuperTeamTable dev key until the canonical support org is confirmed.
 const SUPPORT_ORG_KEY = (
  isDev
    ? '4befef7d-a7be-4ade-a567-48465ae130e8'
    : '943a2605-102f-4c18-af86-e9bb0126f098'
) 



















; exports.SUPPORT_ORG_KEY = SUPPORT_ORG_KEY

const openSupportChat = async (args) => {
  const res = await _client2.default.send('SUPER_CreateConversation', args)
  const { BlobjectKey, ConversationKey, Type } = res
  _actions2.default.gotoBlobject(Type, ConversationKey, BlobjectKey)
  return res
}

 const openSupportChatWithUser = (userKey, currentUserKey) =>
  openSupportChat({
    OrgKey: exports.SUPPORT_ORG_KEY,
    UserKeys: [currentUserKey, userKey],
    TeamKeys: [],
    PatientKeys: [],
    ChatName: '',
  }); exports.openSupportChatWithUser = openSupportChatWithUser

 const openSupportChatWithTeam = (teamKey, currentUserKey) =>
  openSupportChat({
    OrgKey: exports.SUPPORT_ORG_KEY,
    UserKeys: [currentUserKey],
    TeamKeys: [teamKey],
    PatientKeys: [],
    ChatName: '',
  }); exports.openSupportChatWithTeam = openSupportChatWithTeam
